import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaHandPointRight, FaUser } from 'react-icons/fa';
import { ROUTES } from '../../assets/constants/strings';
import Sad from '../../assets/images/sad.svg';

import './style.scoped.scss';
import config from '../../config';
import { Button } from 'react-bootstrap';

const ErrorFrame = ({ pageViews = false, user }) => {
  const reasons = [
    'The document or page was removed from the site',
    'Your connection has timed out',
    `You've misspelled the URL`,
    `You don't have access to this document`,
  ];
  return (
    <>
      {pageViews ? (
        <div id='error-frame'>
          <img src={Sad} alt='Oops' />

          <span className='mt-4'>
            <FaHandPointRight />
            The RegulationCity document you requested has not opened as you have
            reached your page view limit of
            <b className='mx-2'>
              <u>{user?.userPlan?.restrictions?.pageviews}</u>
            </b>
            for this period.
          </span>

          <span className='mt-4'>
            Please go to your account to upgrade your plan and access more
            pages.
          </span>

          <Link to={ROUTES.USAGE} className='mt-4'>
            <Button size='lg'>
              <FaUser className='mr-3' />
              My Account
            </Button>
          </Link>
        </div>
      ) : (
        <div id='error-frame'>
          <img src={Sad} alt='Oops' />
          <h3 className='mb-0 mt-3'>
            Something went wrong while loading RegulationCity
          </h3>
          <h4 className='my-2'>Possible Issues</h4>

          {reasons.map((reason, i) => (
            <span key={i}>
              <FaHandPointRight />
              {reason}
            </span>
          ))}

          <span className='my-3'>
            Either refresh the screen to try again or
          </span>
          <Link to={ROUTES.HOME} className='wf-submit'>
            <FaHome className='mr-3' />
            Go to the Home page
          </Link>
          <span>If you keep seeing this error, please</span>
          <a
            href={`${config.WordPressURL}help/`}
            target='_blank'
            rel='noreferrer'
            className='my-account-btn secondary'
          >
            Contact Us
          </a>
        </div>
      )}
    </>
  );
};

export default ErrorFrame;
